import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { signOutHomeGuard } from './core/guards/signout-home.guard';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then(m => m.HomePage),
    canActivate: [signOutHomeGuard]
  },
  {
    path: 'map',
    loadComponent: () => import('./map/map.page').then(m => m.MapPage),
    canActivate: [authGuard]
  },
  {
    path: 'map/:mapId',
    loadComponent: () => import('./map-view/map-view.page').then(m => m.MapViewPage)
  },
  {
    path: 'diagnostics',
    loadComponent: () => import('./diagnostics/diagnostics.page').then(m => m.DiagnosticsPage)
  },
  {
    path: 'appcheck-init',
    loadComponent: () => import('@shared').then(m => m.AppCheckInitComponent),
    data: { siteKey: environment.appCheck?.siteKey, defaultHref: '/home' }
  },
  {
    path: '**',
    loadComponent: () => import('@shared').then(m => m.NotFoundComponent),
    data: { toolbarColor: 'storm-blue', homeRoute: '/home' }
  }
];

